import React__default, { useMemo, useEffect } from 'react';
import { useDispatch, useSelector, statusFailed } from '@grandvisionhq/state';
import { getUnlinkOrderCall } from '../selectors.js';
import UnlinkView from './UnlinkView.js';
import { unlinkOrder, unlinkOrderFailed } from './actions.js';

const UnlinkOrderContainer = ({ isSuccessPage , orderNumber ='' , orderToken  })=>{
    const dispatch = useDispatch();
    const unlinkOrderCall = useSelector(getUnlinkOrderCall);
    const viewType = useMemo(()=>{
        if (isSuccessPage) {
            return 'success';
        } else {
            return statusFailed(unlinkOrderCall) ? 'failed' : undefined;
        }
    }, [
        isSuccessPage,
        unlinkOrderCall
    ]);
    useEffect(()=>{
        if (!isSuccessPage) {
            if (orderToken) {
                dispatch(unlinkOrder({
                    orderToken,
                    orderNumber
                }));
            } else {
                dispatch(unlinkOrderFailed(new Error('Cannot unlink an order without an orderToken')));
            }
        }
    }, [
        dispatch,
        orderNumber,
        isSuccessPage,
        orderToken
    ]);
    return /*#__PURE__*/ React__default.createElement(UnlinkView, {
        viewType: viewType,
        unlinkedItemId: orderNumber,
        unlinkType: "unlinkOrder"
    });
};
var UnlinkOrderContainer$1 = /*#__PURE__*/ React__default.memo(UnlinkOrderContainer);

export { UnlinkOrderContainer$1 as default };
//# sourceMappingURL=UnlinkOrderContainer.js.map
